import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { PhoneIcon } from '@heroicons/react/24/solid';
import Logo from './Logo';

const Footer: React.FC = () => {
  const { translations } = useLanguage();
  
  return (
    <footer className="bg-navy text-white py-12">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Column 1: Impressum */}
          <div>
            <h3 className="text-xl font-bold mb-4">{translations.footer.legal.title}</h3>
            <p className="mb-2">
              <Link to="/impressum" className="text-white hover:text-mint transition-colors">
                {translations.nav.legalNotice}
              </Link>
            </p>
            <p className="mb-2">
              <Link to="/datenschutz" className="text-white hover:text-mint transition-colors">
                {translations.footer.legal.privacy}
              </Link>
            </p>
            <p className="mb-2">
              <button 
                onClick={() => window.reopenCookieSettings?.()}
                className="text-white hover:text-mint transition-colors underline cursor-pointer"
              >
                {translations.footer.legal.cookieSettings}
              </button>
            </p>
            <p className="mb-2">
              <a
                href="https://admin.seadent.es/admin/login"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-mint transition-colors text-sm opacity-75"
              >
                Admin
              </a>
            </p>
          </div>

          {/* Column 2: Navigation */}
          <div>
            <h3 className="text-xl font-bold mb-4">{translations.footer.links.title}</h3>
            <nav className="flex flex-col space-y-2">
              <Link to="/" className="text-white hover:text-mint transition-colors">{translations.footer.links.home}</Link>
              <Link to="/kontakt" className="text-white hover:text-mint transition-colors">{translations.footer.links.contact}</Link>
              <Link to="/kontakt?booking=true" className="text-white hover:text-mint transition-colors">{translations.footer.links.book}</Link>
              <Link to="/emergency" className="text-white hover:text-coral transition-colors flex items-center">
                <PhoneIcon className="w-4 h-4 mr-1" />
                {translations.nav.emergency}
              </Link>
            </nav>
          </div>

          {/* Column 3: Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">{translations.footer.contact.title}</h3>
            <div className="space-y-2">
              <p>{translations.footer.contact.practice}</p>
              <p>{translations.footer.contact.address}</p>
              <p>{translations.footer.contact.city}</p>
              <p>{translations.footer.contact.owner}</p>
              <p className="mt-4">
                <a href="tel:+34603319648" className="text-white hover:text-mint transition-colors">
                  {translations.footer.contact.phone}
                </a>
              </p>
              <p className="mt-2">
                <a href="https://wa.me/+34603319648" className="text-white hover:text-mint transition-colors flex items-center">
                  <span>{translations.footer.contact.whatsapp}</span>
                </a>
              </p>
              <p className="mt-2">
                <a href="mailto:info@seadent.es" className="text-white hover:text-mint transition-colors">
                  {translations.footer.contact.email}
                </a>
              </p>
              <p className="mt-2">{translations.footer.contact.hours}</p>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-700 text-center">
          <div className="flex justify-center mb-4">
            <Logo className="h-12 w-auto" color="#FFFFFF" />
          </div>
          <p>{translations.footer.copyright.replace('{year}', String(new Date().getFullYear()))}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 